import FlagIcon from "@mui/icons-material/Flag"
import { Box } from "@mui/material"
import { ReactElement } from "react"

import AppTooltip from "../helper/appTooltip"

/**
 * Icon with padding for displaying alert flag on search screen.
 * @returns <AlertFlag />
 */
export const AlertFlag = (): ReactElement => (
    <Box
        style={{
            paddingLeft: "8px",
        }}
        data-testid="alertFlag"
    >
        <AppTooltip title="An alert has been raised on this device">
            <FlagIcon color="warning" />
        </AppTooltip>
    </Box>
)

export default AlertFlag
